<template>
  <main-layout>
    <h5
      v-if="scrollY > 200"
      class="position-fixed fixedHeader"
    >
      {{ $store.state.adminCurrentContract.ContractNumber }} -
      {{ $store.state.adminCurrentContract.ShortName }} (Version
      {{ $store.state.adminCurrentContract.Version }})
    </h5>
    <b-row>
      <b-tabs class="contractOverViewTabControl">
        <b-tab
          title="Vertrag-Details"
          active
        >
          <b-card class="shadow-sm">
            <contract-details
              :contract-id="vertragsId"
              :latest-version-short-name="latestVersionShortName"
            />
          </b-card>
        </b-tab>
        <b-tab title="Stichwörter">
          <b-card class="shadow-sm">
            <contract-keywords :contract-id="vertragsId" />
          </b-card>
        </b-tab>
      </b-tabs>
    </b-row>
    <versions-tabs
      class="mt-4"
      :contract-id="vertragsId"
      :version-number="versionNumber"
      @displayVersionChanged="ChangeVersionNumber"
      @latestVersionLoaded="
        (versionName) => {
          latestVersionShortName = versionName;
        }
      "
    />

    <!-- This is not very pretty, but it prevents the browser jumping all over the place
    when switching between the tabs due to different heights of the controls in the tabs-->
    <div style="height: 500px" />
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import ContractDetails from "@/components/contract/ContractDetails.vue";
import ContractKeywords from "@/components/contract/ContractKeywords.vue";
import VersionsTabs from "@/components/contract/version/VersionsTabs.vue";

export default {
  components: {
    MainLayout,
    ContractDetails,
    ContractKeywords,
    VersionsTabs,
  },
  data() {
    return {
      vertragsId: "",
      versionNumber: 0,
      editionsId: 0,
      topTabControl: null,
      latestVersionShortName: "",
      scrollY: window.pageYOffset,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  created() {
    this.vertragsId = this.$route.params.vertragsId;
    this.versionNumber = Number.parseInt(this.$route.params.versionNumber);
    this.editionsId = Number.parseInt(this.$route.params.editionsId);
  },
  methods: {
    ChangeVersionNumber(newVersionNumber) {
      this.versionNumber = newVersionNumber;
    },
    onScroll() {
      this.scrollY = window.pageYOffset;
    },
  },
};
</script>

<style>
.vue-fixed-header--isFixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  opacity: 0;
  animation: fadeIn 0.3s ease-out forwards;
}
.contractOverViewTabControl .shadow-sm {
  border-top: none;
  border-radius: 0px;
}
.contractOverViewTabControl {
  width: 100%;
}
.tab-pane {
  outline: none !important;
}
</style>

<style scoped>
.fixedHeader {
  z-index: 50;
  top: 0px;
  background-color: rgb(74, 74, 74);
  color: white;
  padding: 15px;
  margin-left: -14px;
  max-width: 1120px;
  width: 100%;
  border: 1px solid rgb(202, 202, 202);
}

@media (max-width: 1904px) {
  .fixedHeader {
    max-width: 1074px;
  }
}

@media (max-width: 1199px) {
  .fixedHeader {
    max-width: 894px;
  }
}
@media (max-width: 992px) {
  .fixedHeader {
    max-width: 654px;
  }
}
</style>
